import { SIZE } from '../config/mobile';

export default () => window.innerWidth <= SIZE;
